import * as React from 'react';
import { Container } from 'flux/utils';
import idx from 'idx';

import { loadGroupAvatars, fetchGroupAvatar } from 'actions/AvatarActions';
import Avatar from 'entities/Avatar';
import AvatarStore from 'stores/AvatarStore';
import errorLogger from 'utils/errorLogger';
import GroupAvatarPicker from './GroupAvatarPicker';
import Image from 'components/Image';
import Link from 'components/Link';
import ModalTrigger from 'components/ModalTrigger';
import MediaObject from 'components/MediaObject';

import './styles/GroupAvatarSelector.scss';

const MIN_HIDDEN_AVATAR_ID = 9001;

type Props = {
  onSelect: (a: Avatar) => {};
  initialAvatar: Avatar | undefined | null;
  horizontal?: boolean;
};

type State = {
  avatar: Avatar;
};

class GroupAvatarSelector extends React.Component<Props, State> {
  static getStores() {
    return [AvatarStore];
  }

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'prevState' implicitly has an 'any' type... Remove this comment to see the full error message
  static calculateState(prevState, props) {
    let avatar = null;

    if (prevState && prevState.avatar) {
      avatar = prevState.avatar;
    } else {
      if (props.initialAvatar) {
        avatar = AvatarStore.getGroupAvatars().get(props.initialAvatar.id);
        // HACK: In order to display hidden avatars for classes that have them selected
        if (!avatar && props.initialAvatar.id >= MIN_HIDDEN_AVATAR_ID) {
          avatar = props.initialAvatar;
        }
      } else {
        avatar = AvatarStore.getGroupAvatars().getRandomAvatar();
      }
    }

    return {
      avatar,
    };
  }

  componentDidMount() {
    if (!AvatarStore.areGroupAvatarsLoaded()) {
      loadGroupAvatars();
    }
  }

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'avatar' implicitly has an 'any' type.
  onAvatarSelected = (avatar) => {
    this.setState({ avatar });
    this.props.onSelect(avatar);
  };

  getSelectedAvatar = () => {
    return this.state.avatar;
  };

  getSelectedAvatarId = () => {
    return idx(this.state, (_) => _.avatar.id);
  };

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'name' implicitly has an 'any' type.
  searchAvatarForName = (name) => {
    fetchGroupAvatar(name)
      .then((avatars) => {
        const avatar = avatars.first();

        if (avatar) {
          this.setState({ avatar });
        }
      })
      .catch(errorLogger('GroupAvatarSelector fetchGroupAvatar failed'));
  };

  renderAvatar = () => {
    return <Image className="GroupAvatarSelector-Avatar" src={this.state.avatar.getUrl()} circle />;
  };

  renderPlaceholder = () => {
    return <div className="GroupAvatarSelector-Placeholder" />;
  };

  render() {
    const groupAvatarPickerModal = (
      <GroupAvatarPicker
        onSelect={this.onAvatarSelected}
        selectedAvatar={this.state.avatar ? this.state.avatar.id : null}
      />
    );

    if (this.props.horizontal) {
      return (
        <div className="GroupAvatarSelector">
          <MediaObject center gutter="medium">
            {this.state.avatar ? this.renderAvatar() : this.renderPlaceholder()}
            <ModalTrigger modal={groupAvatarPickerModal}>
              <div className="GroupAvatarSelector-Subtext">
                <Link href="#">Change avatar</Link>
              </div>
            </ModalTrigger>
          </MediaObject>
        </div>
      );
    } else {
      return (
        <div className="GroupAvatarSelector">
          <ModalTrigger modal={groupAvatarPickerModal}>
            <div>
              {this.state.avatar ? this.renderAvatar() : this.renderPlaceholder()}

              <div className="GroupAvatarSelector-Subtext">
                <Link href="#">Edit icon</Link>
              </div>
            </div>
          </ModalTrigger>
        </div>
      );
    }
  }
}

export default Container.create(GroupAvatarSelector, {
  withProps: true,
  pure: false,
});
